import { render, staticRenderFns } from "./projectAdvantageWidge.vue?vue&type=template&id=c5c3f580&scoped=true"
import script from "./projectAdvantageWidge.vue?vue&type=script&lang=js"
export * from "./projectAdvantageWidge.vue?vue&type=script&lang=js"
import style0 from "./projectAdvantageWidge.vue?vue&type=style&index=0&id=c5c3f580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c3f580",
  null
  
)

export default component.exports